import { RouterProvider } from 'react-router-dom';

// third-party
import { Toaster } from 'react-hot-toast';

// project imports
import router from 'routes';
import ThemeCustomization from 'themes';

import ScrollTop from 'components/ScrollTop';

// ==============================|| APP - THEME, ROUTER, LOCAL ||============================== //

export default function App() {
  return (
    <ThemeCustomization>
      <ScrollTop>
        <Toaster 
          position="top-right" 
          reverseOrder={false} 
          toastOptions={{
            style: {
              background: 'rgba(var(--palette-background-paperChannel) / 0.85)',
              color: 'var(--palette-text-primary)',
              backdropFilter: 'blur(20px) saturate(190%)',
              WebkitBackdropFilter: 'blur(20px) saturate(190%)',
              border: '1px solid rgba(var(--palette-dividerChannel) / 0.2)',
              borderRadius: '16px',
              boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.2)'
            },
            success: {
              iconTheme: {
                primary: 'var(--palette-success-main)',
                secondary: 'var(--palette-background-paper)'
              }
            },
            error: {
              iconTheme: {
                primary: 'var(--palette-error-main)',
                secondary: 'var(--palette-background-paper)'
              }
            }
          }}
        />
        <RouterProvider router={router} />
      </ScrollTop>
    </ThemeCustomization>
  );
}
  